import { getDataString } from "../../util/Months";

const data = new Date();



const InitialDashboard ={
    isLoadingCards: false,
    isLoadingDays: false,
    cards:{
        0:[
            {
                "Active": false,
                "type": 1,
                "focus": true,
            },
            {
                "Active": false,
                "type": 1,
            },
            {
                "Active": false,
                "type": 1,
            },
            {
                "Active": false,
                "type": 1,
            },
        ],
        
        1:[
            {
                "Active": false,
                "type": 1,
            },
        ]
    },
    name: '',
    hasMoreCards: {
        1: false,
    },
    days: [],
    day: getDataString(data.getDate()),
    month: getDataString(data.getMonth()+1),
    year: data.getFullYear(),
    Equipamentos: [],
    donutGraph:[
        {
          "label": "loss",
          "value": 0,
          "color": "#3E73A8"
        },
        {
          "label": "consumption",
          "value": 0,
          "color": "#55965E"
        },
        {
          "label": "production",
          "value": 0,
          "color": "#006560"
        }
    ],
    donutGraphTotal:[
        {
          "label": "total",
          "color": "#3E73A8",
          "itens": [],
          "total":0,
          "unit": ""
        },
        {
          "label": "consumption",
          "color": "#55965E",
          "itens": [],
          "total":0,
          "unit": ""
        },
        {
          "label": "credits",
          "color": "#006560",
          "itens": [],
          "total":0,
          "unit": ""
        },
        {
          "label": "percentage-loss",
          "itens": [],
          "total":0,
          "unit": ""
        }
    ],
    Mode: 0,
    status: 0,
    title: '',
    dados: [],
    CardStatus: 7
}

export default function DashboardControlePerdasReducer ( PrevState = InitialDashboard, action){
    switch (action.type) {
        case 'ChangeLossControlCards':
            return{
                ...PrevState,
                cards : action.payload.cards,
                name : action.payload.name
            };
        case 'changeDonutData':
            return {
                ...PrevState,
                donutGraph: action.payload.donutGraph
            };
        case 'changeDonutDataTotal':
            return {
                ...PrevState,
                donutGraphTotal: action.payload.donutGraphTotal
            };
        case 'ChangeLossControlTotalCards':
            return{
                ...PrevState,
                hasMoreCards : {
                    ...PrevState.hasMoreCards,
                    ...action.payload.hasMoreCards
                },
            };
        case 'ChangeLossControlDays' :
            return{
                ...PrevState,
                days: action.payload.days
            };
        case 'ChangeLossControlDay':
            return {
                ...PrevState,
                day: action.payload.day
            };
        case 'ChangeLossControlMonth':
            return {
                ...PrevState,
                month: action.payload.month
            };
        case 'ChangeLossControlCardsLoading' :
            return{
                ...PrevState,
                isLoadingCards : action.payload.isLoading
            };
        case 'ChangeLossControlDaysLoading' :
            return{
                ...PrevState,
                isLoadingDays : action.payload.isLoading
            };
        case 'ChangeLossControlAutoplay':
            return {

                ...PrevState,
                isAutoplayEnabled: action.payload.isAutoplayEnabled
            };
        case 'ChangeLossControlyear':
            return {
                ...PrevState,
                year: action.payload.year
            };
        case 'ChangeLossControlStatus':
            return {
                ...PrevState,
                CardStatus: action.payload.status
            };
         case 'ChangeLossControlMode':
            return {
                ...PrevState,
                Mode: action.payload.mode
            };
        default:
            return PrevState;
    }
}